import gql from "graphql-tag";
import moment from "moment";
import qs from "query-string";


export type Balance = {
    VATRate: string
    balance: number
    deposit: number
    clearBalance: number
    currency: string
}

export type Contract = {
    id: string
    group: string
    number: string
    active: boolean
    subtotalBalance: Balance[]
}


export type GetFinanceVars = {

}
export type GetFinanceResult = {
    contractsBalance: {
        contracts: Contract[]
        totalBalance: Balance[]
    }
}
export const GetFinanceDocument = gql`
    query GetFinance {
        contractsBalance @rest(path: "remote/erp/api/v2/contracts?balance") {
            contracts {
                id
                group
                number
                active
                subtotalBalance {
                    VATRate
                    balance
                    deposit
                    clearBalance
                    currency
                }
            }
            totalBalance {
                VATRate
                balance
                deposit
                clearBalance
                currency
            }
        }
    }
`


export type GetTariffAgreementsVars = {}
export type GetTariffAgreementsResult = {
    tariffAgreements: {
        tariffAgreements: {
            id: string
            number: string
            typical: boolean
        }[]
    }
}
export const GetTariffAgreementsDocument = gql`
    query GetTariffAgreements {
        tariffAgreements @rest(path: "remote/erp/api/v2/tariff-agreements") {
            tariffAgreements {
                id
                number
                typical
            }
        }
    }
`


export const GetFinanceReconciliationDocument = gql`
    query GetFinanceReconciliation($dateFrom: Date, $dateTo: Date, $pdf: Boolean, $email: String) {
        financeReconciliation(dateFrom: $dateFrom, dateTo: $dateTo, pdf: $pdf, email: $email) @rest(pathBuilder: $pathBuilder) {
            financeReconciliation {
                balance {
                    openingBalance
                    closingBalance
                }
                documents {
                    date
                    number
                    type
                    amount
                }
            }
        }
    }
`;

export function GetFinanceReconciliationPathBuilder({args}) {
    const url = "remote/erp/api/v2/finance-reconciliation";
    const params = {};
    const format = "YYYY-MM-DD";
    if (args.dateFrom) {
        params["date-from"] = moment(args.dateFrom).format(format);
    }
    if (args.dateTo) {
        params["date-to"] = moment(args.dateTo).format(format);
    }
    if (args.pdf) {
        params["pdf"] = "";
    }
    if (args.email) {
        params["email"] = args.email;
    }
    return url + "?" + qs.stringify(params);
}

export type GetFinanceReconciliationVars = {
    dateFrom: Date
    dateTo: Date
    pdf?: boolean
    email?: string
    pathBuilder: typeof GetFinanceReconciliationPathBuilder
}
export type GetFinanceReconciliationResult = {
    financeReconciliation: {
        financeReconciliation: {
            balance: {
                openingBalance: number
                closingBalance: number
            }
            documents: {
                date: string
                number: string
                type: string
                amount: number
            }[]
        }
    }
}